/**
 * QuotaGauge component for displaying quota usage with visual gauge.
 */
import React from 'react';
import './QuotaGauge.css';

interface QuotaGaugeProps {
  label: string;
  allocated: number;
  quota?: number | null;
}

export const QuotaGauge: React.FC<QuotaGaugeProps> = ({ label, allocated, quota }) => {
  const percentage = quota && quota > 0 ? Math.min(100, Math.round((allocated / quota) * 100)) : 0;
  
  let gaugeColor = 'var(--success-color)'; // Green
  if (percentage >= 90) {
    gaugeColor = 'var(--error-color)'; // Red
  } else if (percentage >= 70) {
    gaugeColor = 'var(--warning-color)'; // Yellow
  }

  return (
    <div className="quota-gauge">
      <div className="quota-gauge-header">
        <span className="quota-gauge-label">{label}</span>
        <span className="quota-gauge-value">
          {allocated}
          {quota ? ` / ${quota}` : ''}
        </span>
      </div>
      {quota && quota > 0 ? (
        <div className="quota-gauge-bar">
          <div
            className="quota-gauge-fill"
            style={{
              width: `${percentage}%`,
              backgroundColor: gaugeColor,
            }}
          />
        </div>
      ) : (
        <div className="quota-gauge-bar quota-gauge-bar-no-quota">
          <div className="quota-gauge-fill" style={{ width: '0%' }} />
        </div>
      )}
    </div>
  );
};


